import { render, staticRenderFns } from "./FnbOwnerStatus.vue?vue&type=template&id=15273d95&"
import script from "./FnbOwnerStatus.vue?vue&type=script&lang=ts&"
export * from "./FnbOwnerStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports